var _a, _b, _c;
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import tasksReducer from './tasksSlice';
import errorSlice from './UI/errorSlice';
import loaderSlice from './UI/loaderSlice';
import notificationReducer from './notificationSlice';
import toastSlice from './UI/toastSlice';
import appSlice from './appSlice';
import { loadState, saveState } from './localStorage';
const persistedState = loadState();
const initialAuthState = {
    id: '',
    email: '',
    name: '',
    accessToken: '',
    keepLogged: false,
};
const store = configureStore({
    reducer: {
        auth: authReducer,
        tasks: tasksReducer,
        notification: notificationReducer,
        error: errorSlice,
        loader: loaderSlice,
        success: toastSlice,
        app: appSlice,
    },
    preloadedState: {
        auth: (_a = persistedState === null || persistedState === void 0 ? void 0 : persistedState.auth) !== null && _a !== void 0 ? _a : initialAuthState,
        tasks: (_b = persistedState === null || persistedState === void 0 ? void 0 : persistedState.tasks) !== null && _b !== void 0 ? _b : [],
        notification: (_c = persistedState === null || persistedState === void 0 ? void 0 : persistedState.notification) !== null && _c !== void 0 ? _c : [],
    },
});
store.subscribe(() => {
    saveState(store.getState());
});
export default store;
